// @flow
import Article from 'components/newsletter/Article';
import { connect } from 'react-redux';

import { fetchArticle, fetchArticlePreview, articleFetched } from 'actions/articleActions';
import type { DispatchType, StateType } from 'types/Actions';
import type { DispatchProps, StateProps } from 'components/newsletter/Article';
import type { ArticleType } from 'types/Article';

export default connect(
  (state: StateType): StateProps => ({
    article: state.articleState.article,
    club: state.settingsState.structure,
    status: state.articleState.status,
    articles: state.newsletterState.articles,
    placeholder: state.settingsState.placeholder,
    organization: state.settingsState.title,
    logo: state.settingsState.logo,
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchArticle: (slug: string) => dispatch(fetchArticle(slug)),
    fetchArticlePreview: (id: number) => dispatch(fetchArticlePreview(id)),
    articleFetched: (article: ArticleType) => dispatch(articleFetched(article))
  })
)(Article);
